import React from "react";

import StepsListItem from "@/legacy/transaction/transaction_script_editor/StepsListItem.jsx";
import Utils from "@/legacy/Utils.js";

export default class StepsList extends React.Component {
  constructor(props) {
    super(props);
    Utils.autoBindClass(this);
    this.state = {
      dropdownIndex: null,
    };
  }

  render() {
    return <ul className="transaction-steps mb-0">{this.renderSteps()}</ul>;
  }

  renderSteps() {
    return this.props.transactionScript.map(
      function (step, i) {
        return (
          <StepsListItem
            key={i}
            index={i}
            shortSelectors={this.props.shortSelectors}
            step={step}
            allowMove={this.props.allowReorder}
            selected={this.props.selectedIndex === i}
            helpText={this.props.transactionScript[i].help_text}
            verboseName={this.props.transactionScript[i].verbose_name}
            htmlElementList={this.props.htmlElementList}
            transactionStepDefs={this.props.transactionStepDefs}
            transactionStepDefsMap={this.props.transactionStepDefsMap}
            handleAddStart={this.props.handleAddStart}
            onSelectElement={this.props.onSelectElement}
            onSelectElementCompleted={this.props.onSelectElementCompleted}
            onSelectStep={this.props.onSelectStep}
            onDeleteStep={this.props.onDeleteStep}
            onReorderStep={this.props.onReorderStep}
            onReplaceStep={this.props.onReplaceStep}
            onUpdateSelectedStepField={this.props.onUpdateSelectedStepField}
            onUpdateSelectedStepTitle={this.props.onUpdateSelectedStepTitle}
            monitoringServiceType={this.props.monitoringServiceType}
            onUpdateStepValues={this.props.onUpdateStepValues}
            onOpenURL={this.props.onOpenURL}
            enabledFeatureFlags={this.props.enabledFeatureFlags}
            onShowDropdown={this.onShowDropdown}
            dropdownIndex={this.state.dropdownIndex}
          />
        );
      }.bind(this)
    );
  }

  onShowDropdown(index, show) {
    if (show) {
      this.setState({dropdownIndex: index});
    } else if (this.state.dropdownIndex === index) {
      this.setState({dropdownIndex: null});
    }
  }
}

StepsList.defaultProps = {
  transactionScript: [],
  selectedIndex: -1,
};
